import {
  useMemo,
} from "react";

export default function CostBreakdown({
  agCost,
  startingRoleMoney = 0,
}: {
  agCost?: any,
  startingRoleMoney?: number,
}) {

  const estimatedCosts = useMemo(() => {
    let result = 0;

    for (let i = 0; i < agCost?.metaBalanceChanges.length; i++) {
      if (agCost?.metaBalanceChanges[i].balance < 0) {
        result += -1 * agCost?.metaBalanceChanges[i].balance;
      }
    }

    for (let i = 0; i < agCost?.MUBalanceChanges.length; i++) {
      for (let j = 0; j < agCost?.MUBalanceChanges[i].length; j++) {
        if (agCost?.MUBalanceChanges[i][j].balance < 0) {
          result += -1 * agCost?.MUBalanceChanges[i][j].balance;
        }
      }
    }

    return Math.round(result);
  }, [agCost]);

  const estimatedRevenue = useMemo(() => {
    let result = 0;

    for (let i = 0; i < agCost?.metaBalanceChanges.length; i++) {
      if (agCost?.metaBalanceChanges[i].balance > 0) {
        result += agCost?.metaBalanceChanges[i].balance;
      }
    }

    for (let i = 0; i < agCost?.MUBalanceChanges.length; i++) {
      for (let j = 0; j < agCost?.MUBalanceChanges[i].length; j++) {
        if (agCost?.MUBalanceChanges[i][j].balance > 0) {
          result += agCost?.MUBalanceChanges[i][j].balance;
        }
      }
    }

    return Math.round(result);
  }, [agCost]);

  function roundNumbersInString(str: string) {
    return str.replace(/\d+(\.\d+)?/g, (match) => Math.round(parseFloat(match)).toString());
  }

  return (
    <div className="flex flex-col h-full">
      <label>Associated Costs with Selected Water Regime and Actions</label>

      <div className="h-4"/>

      <div className="flex flex-row justify-between">
        <label>{`Start of the year balance:`}</label>
        <label>{`${Math.round(startingRoleMoney)}`}</label>
      </div>

      <div className="h-2"/>
      
      {agCost?.metaBalanceChanges?.map((change: any, i: number) => (
        <div key={i} className="flex flex-row justify-between">
          <label>{`${roundNumbersInString( change.description )}:`}</label>
          <label>{`${change.balance > 0 ? '+' : ''}${Math.round(change.balance)}`}</label>
        </div>
      ))}

      <div className="h-1"/>

      {agCost?.MUBalanceChanges?.map((changes: any[], i: number) => (
        changes.map((change: any, j: number) => (
          <div key={`${i}-${j}`} className="flex flex-row justify-between">
            <label>{`${change.description } in Management Unit ${i}:`}</label>
            <label>{`${change.balance > 0 ? '+' : ''}${Math.round(change.balance)}`}</label>
          </div>
        ))
      ))}

      <div className="h-2 border-b border-black"/>

      <div className="flex flex-row justify-between">
        <label>{`Remaining Balance:`}</label>
        <label>{`${Math.round(startingRoleMoney + agCost?.totalBalanceChange)}`}</label>
      </div>

      <div className="h-6"/>

      <label className="text-center pb-4">Summary</label>

      <div className="flex flex-row justify-between">
        <label>{`Total Costs:`}</label>
        <label>{`-${estimatedCosts}`}</label>
      </div>
      <div className="flex flex-row justify-between">
        <label>{`Total Revenue:`}</label>
        <label>{`${estimatedRevenue}`}</label>
      </div>
      <div className="flex flex-row justify-between">
        <label>{`Change in balance:`}</label>
        <label>{`${Math.round(agCost?.totalBalanceChange)}`}</label>
      </div>
      <div className="flex flex-row justify-between">
        <label>{`Remaining Balance:`}</label>
        <label>{`${Math.round(startingRoleMoney + agCost?.totalBalanceChange)}`}</label>
      </div>
    </div>
  )
}
